import React from 'react';
import PropTypes from 'prop-types';
import NumericField from './numericField';

const ReportCurrencyField = (props) => {
	let classes = 'report-field';
	if (props.editable !== false) {
		classes += ' editable';
	}
	
	const style = {
		width: '100px', 
		lineHeight: '14px',
		height: '18px',
		...props.style
	};
	const inputStyle = {
		fontSize: '12px', 
		textAlign: 'right',
			padding: '2px',
			...props.inputStyle
	};

	const mergedProps = { ...props };
	delete mergedProps.editable;
	
	return (
		<NumericField 
			{...mergedProps} 
			type="currency" 
			className={classes}
			disableUnderline={true}
			style={style} 
			inputStyle={inputStyle} 
		/>
	);
};

ReportCurrencyField.propTypes = {
	editable: PropTypes.bool,
	style: PropTypes.object,
	inputStyle: PropTypes.object
};

ReportCurrencyField.defaultProps = {
	style: {},
	inputStyle: {},
	editable: false
};

export default ReportCurrencyField;
